export default import.meta.ROLLDOWN_FILE_URL_HjVUT5MpswcpgY2Kt4Q2FQ